// extracted by mini-css-extract-plugin
export default {"wrapper":"TextHeader_wrapper__UD569","header":"TextHeader_header__3ACbD","tooltip":"TextHeader_tooltip__NUHkM"};